<app-header></app-header>
<app-resume-step></app-resume-step>
<div class="container mx-auto mb-[4rem]">
  <app-info-top></app-info-top>
  <app-question [question]="question" [popupInfo]="question.popupInfo" [local]="true">
    <div class="flex items-center clickable-card-parent flex-wrap justify-center gap-4">
      <div
        class="clickable-card flex flex-col justify-center w-full text-center items-center cursor-pointer"
        (click)="onHouseSelected()"
        (keydown)="onHouseSelected()"
        [ngClass]="setClassActive(houseSelected)">
        <div class="house"></div>
        <div class="flex flex-row items-center pb-8 place-content-between">
          <p class="mr-2">{{ resource.houseapartment.house }}</p>
        </div>
      </div>

      <div
        class="clickable-card flex flex-col justify-center w-full text-center items-center cursor-pointer"
        (click)="onFlatSelected()"
        (keydown)="onFlatSelected()"
        [ngClass]="setClassActive(flatSelected)">
        <div class="appartment"></div>
        <div class="flex flex-row items-center pb-8 place-content-between">
          <p class="mr-2">{{ resource.houseapartment.apartment }}</p>
        </div>
      </div>
      <div
        *ngIf="path === pathType.HOUSING_ETUDIANTE"
        class="clickable-card flex flex-col justify-center w-full text-center cursor-pointer items-center"
        (click)="onRoomSelected()"
        (keydown)="onRoomSelected()"
        [ngClass]="setClassActive(roomSelected)">
        <div class="less-10"></div>
        <div class="flex flex-row items-center pb-4 place-content-between">
          <p class="two-lines">{{ resource.houseapartment.room }}</p>
        </div>
      </div>

      <div
        class="clickable-card flex flex-col justify-center w-full text-center cursor-pointer items-center"
        (click)="onOtherSelected()"
        (keydown)="onOtherSelected()"
        [ngClass]="setClassActive(otherSelected)">
        <div class="other"></div>
        <div class="flex flex-row items-center pb-4 place-content-between">
          <p class="two-lines">{{ resource.houseapartment.other }}</p>
        </div>
      </div>
    </div>
  </app-question>
</div>

<div class="container mx-auto h-28 md:h-40">
  <app-footer class="footer"></app-footer>
</div>
<app-web-callback></app-web-callback>

<app-web-callback-popup [show]="displayModal" (cancel)="cancel()"></app-web-callback-popup>
